export type RevertFilterAdvancedFilterState = Record<string, unknown>
export type RevertFilterGridState = Record<string, unknown>

export interface RevertFilterState {
  grid: RevertFilterGridState
  advancedFilters: RevertFilterAdvancedFilterState
}

/**
 * Create a blank filter state
 */
export function createRevertFilterState(): RevertFilterState {
  return { grid: {}, advancedFilters: {} }
}
